import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  TextField,
  Typography,
  debounce,
  makeStyles,
} from "@material-ui/core";
import {
  FilterButton,
  GeneralModal,
  Searchbar,
  SortButton,
} from "../components-molecules";

import { Add } from "@material-ui/icons";
import CssBaseline from "@material-ui/core/CssBaseline";
import { HeaderWithButtons } from "../components-molecules";
import React, { useEffect, useState } from "react";
import { ShopInfoCardList } from "../components-organisms";
import { clearGetShops } from "../redux/actions/getShops";
import { ITheme, theme } from "../constants/theme";
import { useDispatch, useSelector } from "react-redux";
import { ButtonWithLoadingIndicator, CancelButton } from "../components-atoms";
import { IFilter } from "../components-molecules/FilterButton";
import { IPromotionCodeFilter } from "../redux/actions/promotionCodes";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { getShopCities } from "../redux/actions/getShopCities";
import { getShopRegions } from "../redux/actions/getShopRegions";
import { ASC_SORT, SortOption } from "../utils/sortType";
import { addShop } from "../redux/actions/addShop";
import { EMAIL_PATTERN } from "../constants/validation";
import { HeaderWithButtonsResponsive } from "../components-molecules/HeaderWithButtonsResponsive";

// import { setError } from "../redux/actions/error";
interface ShopFormI {
  Name?: string;
  Email?: string;
  Line1?: string;
  Line2?: string;
  PostalCode?: string;
  City?: string;
  County?: string;
}
export type SortType = "asc" | "desc";
const timeoutDuration: number = 500;

const ShopList = (props: any) => {
  const classes = useStyles();
  const [sortType, setSortType] = React.useState<SortType>("asc");
  const dispatch = useDispatch();
  const [openAddShopModal, setAddOpenShopModal] =
    React.useState<boolean>(false);
  const emptyForm: ShopFormI = {
    Name: "",
    Email: "",
    Line1: "",
    Line2: "",
    PostalCode: "",
    City: "",
    County: "",
  };
  const [addShopFormDetails, setAddShopFormDetails] =
    React.useState<null | ShopFormI>(emptyForm);
  const [query, setQuery] = useState<string>("");
  const [searchOpen, setSearchOpen] = useState(false);
  const emptyFilter = { City: [], Region: [] };
  const [filters, setFilters] = useState<any>(emptyFilter);
  const [filterOptions, setFilterOptions] = useState(emptyFilter);
  const [cityFilters, regionFilters, addShopLoading] = useSelector(
    (state: any) => [
      state.getShopCities.data,
      state.getShopRegions.data,
      state.addShop.loading,
    ]
  );

  const [refreshList, setRefreshList] = useState(false);

  useEffect(() => {
    dispatch(getShopCities());
    dispatch(getShopRegions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cityFilters && cityFilters.length > 0) {
      const cities = cityFilters.map((item) => ({
        title: item,
        value: item,
      }));
      setFilterOptions((prev) => ({ ...prev, City: cities }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityFilters]);

  useEffect(() => {
    if (regionFilters && regionFilters.length > 0) {
      const regions = regionFilters.map((item) => ({
        title: item,
        value: item,
      }));
      setFilterOptions((prev) => ({ ...prev, Region: regions }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionFilters]);

  const handleChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setAddShopFormDetails({
        ...addShopFormDetails,
        [field]: event.target.value,
      });
    };
  const handleSubmit = (item: any) => {
    if (addShopFormDetails) {
      dispatch(addShop(addShopFormDetails, addShopSuccess));
    }
  };

  const addShopSuccess = () => {
    dispatch(clearGetShops());
    setTimeout(() => {
      setAddShopFormDetails(emptyForm);
      setAddOpenShopModal(false);
      setQuery("");
      setFilters(emptyFilter);
      dispatch(getShopCities());
      dispatch(getShopRegions());
      setRefreshList(true);
    }, 50);
  };

  const debouncedSearchTerm = React.useRef(
    debounce(async (text) => {
      setQuery(text);
      dispatch(clearGetShops());
    }, timeoutDuration)
  ).current;

  const onSearchChange = (event) => {
    debouncedSearchTerm(event.target.value);
  };

  const onSearchCancel = () => {
    setQuery("");
    setSearchOpen(false);
    dispatch(clearGetShops());
  };
  const onFilterSubmit = (submittedFilter: IFilter | IPromotionCodeFilter) => {
    setFilters(submittedFilter);
    dispatch(clearGetShops());
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <HeaderWithButtonsResponsive title="Shops">
          <HeaderWithButtons.ButtonArea>
            <div className={classes.buttonSet}>
              <SortButton
                data-automation="sort-button"
                menuItems={ASC_SORT.map(({ title, value }: SortOption) => ({
                  title,
                  value,
                  handleSelect: () => {
                    setSortType(value);
                    dispatch(clearGetShops());
                  },
                }))}
                selectedSortType={sortType}
              />
              <FilterButton
                defaultOption="City"
                data-automation="filter-button"
                onSubmit={onFilterSubmit}
                inButtonSet
                options={filterOptions}
                filter={filters}
              />
              <IconButton
                data-automation="search-button"
                className={classes.searchIconButton}
                color="primary"
                onClick={() => setSearchOpen(!searchOpen)}
              >
                <SearchRoundedIcon
                  color="primary"
                  className={classes.searchIcon}
                />
              </IconButton>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                className={classes.primaryButton}
                style={{
                  paddingLeft: props.loading ? "12px" : "16px",
                }}
                startIcon={<Add />}
                onClick={() => {
                  setAddOpenShopModal(true);
                }}
              >
                Add Shop
              </Button>
            </div>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtonsResponsive>

        <div className={classes.searchContainer}>
          <Searchbar
            query={query}
            isOpen={searchOpen}
            placeholder="Search Shops"
            onCancel={() => onSearchCancel()}
            onChange={(event) => onSearchChange(event)}
          />
        </div>
        {/* CSS FIX : margin-left: auto */}

        <ShopInfoCardList
          sortType={sortType}
          filters={filters}
          query={query}
          refresh={refreshList}
          resetRefresh={() => setRefreshList(false)}
        />
      </Container>
      <GeneralModal
        title="Add Shop"
        description="Start by giving the shop a name and address. You will be able to add contact information and shop picking hours from details page"
        visible={openAddShopModal}
        onClose={setAddOpenShopModal}
        onSubmit={handleSubmit}
      >
        <GeneralModal.ContentArea>
          <TextField
            placeholder="Shop Name"
            value={addShopFormDetails?.Name}
            onChange={handleChange("Name")}
            variant="outlined"
            margin="normal"
            fullWidth
            id="Shop Name"
            label="Shop Name"
            name="Shop Name"
            error={!shopNameValidation(addShopFormDetails?.Name)}
            autoFocus
            InputProps={{
              classes: {
                root: classes.cssOutlinedInput,
                focused: classes.cssFocused,
                notchedOutline: classes.notchedOutline,
              },
            }}
          />
          <TextField
            placeholder="Shop Email"
            value={addShopFormDetails?.Email}
            onChange={handleChange("Email")}
            variant="outlined"
            margin="normal"
            fullWidth
            id="Email"
            label="Shop Email"
            name="Email"
            error={!shopEmailValidation(addShopFormDetails?.Email)}
            InputProps={{
              classes: {
                root: classes.cssOutlinedInput,
                focused: classes.cssFocused,
                notchedOutline: classes.notchedOutline,
              },
            }}
          />
          <fieldset className={classes.fieldset}>
            <Typography
              variant="subtitle2"
              component="legend"
              className={classes.fieldsetLegend}
            >
              Shop Address
            </Typography>
            <TextField
              placeholder="Address Line 1"
              value={addShopFormDetails?.Line1}
              onChange={handleChange("Line1")}
              variant="outlined"
              margin="normal"
              fullWidth
              id="Line1"
              label="Address line 1"
              name="Line1"
              error={!shopAddressValidation(addShopFormDetails?.Line1)}
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
            <TextField
              placeholder="Address Line 2"
              value={addShopFormDetails?.Line2}
              onChange={handleChange("Line2")}
              variant="outlined"
              margin="normal"
              fullWidth
              id="Line2"
              label="Address line 2"
              name="Line2"
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
            {/********************* */}
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  placeholder="PostalCode"
                  value={addShopFormDetails?.PostalCode}
                  onChange={handleChange("PostalCode")}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="PostalCode"
                  label="Post Code"
                  name="PostalCode"
                  error={
                    !shopPostCodeValidation(addShopFormDetails?.PostalCode)
                  }
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  placeholder="City"
                  value={addShopFormDetails?.City}
                  onChange={handleChange("City")}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="City"
                  label="City"
                  name="City"
                  error={!shopCityValidation(addShopFormDetails?.City)}
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                />
              </Grid>
            </Grid>
            {/********************* */}
            <TextField
              placeholder="County"
              value={addShopFormDetails?.County}
              onChange={handleChange("County")}
              variant="outlined"
              margin="normal"
              fullWidth
              id="County"
              label="County"
              name="County"
              error={!shopCountyValidation(addShopFormDetails?.County)}
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
            <TextField
              placeholder="United Kingdom"
              value="United Kingdom"
              variant="outlined"
              margin="normal"
              fullWidth
              id="Country"
              label="Country"
              name="Country"
              disabled
              InputProps={{
                classes: {
                  root: classes.cssOutlinedInput,
                  focused: classes.cssFocused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
          </fieldset>
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <CancelButton
            onClick={() => {
              setAddOpenShopModal(false);
              setAddShopFormDetails(emptyForm);
            }}
          />

          <ButtonWithLoadingIndicator
            onClick={handleSubmit}
            disabled={SubmitButtonValidation(addShopFormDetails)}
            style={{
              backgroundColor: !SubmitButtonValidation(addShopFormDetails)
                ? theme.palette.primary.main
                : theme.palette.action.disabledBackground,
            }}
            type="submit"
            title="Submit"
            data-automation="add-button"
            loading={addShopLoading}
          />
        </GeneralModal.ButtonArea>
      </GeneralModal>
    </Box>
  );
};
const SubmitButtonValidation = (addShopFormDetails: ShopFormI | null) => {
  if (fieldsAreInitialState(addShopFormDetails)) {
    return true;
  } else {
    return shopNameValidation(addShopFormDetails?.Name) &&
      shopAddressValidation(addShopFormDetails?.Line1) &&
      shopPostCodeValidation(addShopFormDetails?.PostalCode) &&
      shopCityValidation(addShopFormDetails?.City) &&
      shopCountyValidation(addShopFormDetails?.County) &&
      shopEmailValidation(addShopFormDetails?.Email)
      ? false
      : true;
  }
};
const fieldsAreInitialState = (addShopFormDetails: any) => {
  return addShopFormDetails?.Name === "" ||
    addShopFormDetails?.Line1 === "" ||
    addShopFormDetails?.PostalCode === "" ||
    addShopFormDetails?.City === "" ||
    addShopFormDetails?.County === "" ||
    addShopFormDetails?.Email === ""
    ? true
    : false;
};
const shopNameValidation = (text: any) => {
  if (text === undefined) {
    return;
  } else {
    const trimedText = text.trim();

    if (trimedText === "") {
      return true;
    } else {
      return trimedText.length > 2 && trimedText.length < 50 ? true : false;
    }
  }
};
const shopEmailValidation = (text: any) => {
  if (text === undefined) {
    return;
  } else {
    const trimedText = text.trim();
    if (trimedText === "") {
      return true;
    } else {
      return trimedText.length > 2 &&
        trimedText.length < 50 &&
        EMAIL_PATTERN.test(text)
        ? true
        : false;
    }
  }
};
const shopAddressValidation = (text: any) => {
  if (text === undefined) {
    return;
  } else {
    const trimedText = text.trim();
    if (trimedText === "") {
      return true;
    } else {
      return trimedText.length > 2 && trimedText.length < 100 ? true : false;
    }
  }
};
const shopPostCodeValidation = (text: any) => {
  if (text === undefined) {
    return;
  } else {
    const trimedText = text.trim();
    if (trimedText === "") {
      return true;
    } else {
      return trimedText.length >= 3 && trimedText.length < 15 ? true : false;
    }
  }
};
const shopCityValidation = (text: any) => {
  if (text === undefined) {
    return;
  } else {
    const trimedText = text.trim();
    if (trimedText === "") {
      return true;
    } else {
      return trimedText.length > 2 && trimedText.length < 50 ? true : false;
    }
  }
};
const shopCountyValidation = (text: any) => {
  if (text === undefined) {
    return;
  } else {
    const trimedText = text.trim();
    if (trimedText === "") {
      return true;
    } else {
      return trimedText.length > 2 && trimedText.length < 30 ? true : false;
    }
  }
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  tabContainer: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: "8px",
  },
  buttonSet: {
    display: "flex",
    flexDirection: "row",
    paddingRight: "24px",
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary[92],
    },
    "&:active": {
      backgroundColor: theme.palette.primary[76],
    },
  },
  cancelButton: {
    height: "48px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "8px",
    marginRight: "8px",
    "&:hover": {
      backgroundColor: theme.palette.secondary[16],
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[32],
    },
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  primaryButton: {
    marginLeft: "12px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: theme.palette.primary[92],
    },
    "&:active": {
      backgroundColor: theme.palette.primary[76],
    },
  },
  fieldset: {
    margin: "16px 0 0",
    padding: 0,
    border: 0,
  },
  fieldsetLegend: {
    paddingLeft: "14px",
  },
  searchContainer: {
    marginBottom: "24px",
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchIconButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
  },
}));

export default ShopList;
